module.exports = __webpack_public_path__ + "img/序言.6778408b.png";